import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import RequireAuth from 'utils/require-auth';
import { HasPermission } from 'utils/check-permission';
// import ImageGallery from 'ui-component/image-gallery/ImageGallery';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// sample page routing
const RolesManagement = Loadable(lazy(() => import('views/roles-management')));
const AdminUsers = Loadable(lazy(() => import('views/admin-users')));
const AssignPermissions = Loadable(lazy(() => import('views/roles-management/assign-permissions')));

const ReportedProductsList = Loadable(lazy(() => import('views/products-management/products/reportedProducts')));
const ProductsList = Loadable(lazy(() => import('views/products-management/products')));
const OrdersList = Loadable(lazy(() => import('views/products-management/orders')));
const OrderDetails = Loadable(lazy(() => import('views/products-management/orders/order-details')));

const CommunityPosts = Loadable(lazy(() => import('views/community/posts')));
const CommunityPostComments = Loadable(lazy(() => import('views/community/posts/comments')));
const PostCommentReplies = Loadable(lazy(() => import('views/community/posts/replies')));
const ReportedPosts = Loadable(lazy(() => import('views/community/reported-posts')));

const CommunityChats = Loadable(lazy(() => import('views/community/chats/index')));
const ReportedChats = Loadable(lazy(() => import('views/community/reported-chats')));
const ChatViolations = Loadable(lazy(() => import('views/community/chat-violations')));

// const Users = Loadable(lazy(() => import('views/users')));
// const GalleryView = Loadable(lazy(() => import('views/image-gallery')));
const PermissionsListing = Loadable(lazy(() => import('views/roles-management/permissions-listing')));
const PermissionTypes = Loadable(lazy(() => import('views/roles-management/permission-types-listing')));

// const AdvertisersListing = Loadable(lazy(() => import('views/user-management/advertisers')));
// const ContentCreatorsListing = Loadable(lazy(() => import('views/user-management/content-creators')));
const AppUsersListing = Loadable(lazy(() => import('views/user-management/app-users')));
const SellersListing = Loadable(lazy(() => import('views/user-management/sellers')));

const UserSubscriptions = Loadable(lazy(() => import('views/transactions/subscriptions')));
const PrivacyPolicy = Loadable(lazy(() => import('views/app-content/privacy-policy/index')));
const TermsAndCondition = Loadable(lazy(() => import('views/app-content/terms/index')));
const BrandsListing = Loadable(lazy(() => import('views/app-content/brands/index')));
const CategoriesManagement = Loadable(lazy(() => import('views/app-content/categories/index')));
const SizingManagement = Loadable(lazy(() => import('views/app-content/sizes/index')));
const LookingForProducts = Loadable(lazy(() => import('views/looking-for-products')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: (
        <RequireAuth>
          <DashboardDefault />
        </RequireAuth>
      )
    },
    {
      path: 'dashboard',
      element: (
        <RequireAuth>
          <DashboardDefault />
        </RequireAuth>
      )
    },
    {
      path: 'roles-management',
      element: (
        <RequireAuth>
          <HasPermission data={'view-roles'}>
            <RolesManagement />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'admin-users',
      element: (
        <RequireAuth>
          <HasPermission data={'view-admins'}>
            <AdminUsers />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'assign-permissions',
      element: (
        <RequireAuth>
          <AssignPermissions />
        </RequireAuth>
      )
    },
    {
      path: 'products',
      element: (
        <RequireAuth>
          <HasPermission data={'view-products'}>
            <ProductsList />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'reported-products',
      element: (
        <RequireAuth>
          <HasPermission data={'view-products'}>
            <ReportedProductsList />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'looking-for-products',
      element: (
        <RequireAuth>
          <HasPermission data={'view-products'}>
            <LookingForProducts />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'orders',
      element: (
        <RequireAuth>
          <HasPermission data={'view-orders'}>
            <OrdersList />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'order-details',
      element: (
        <RequireAuth>
          <HasPermission data={'view-orders'}>
            <OrderDetails />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'post-comments',
      element: (
        <RequireAuth>
          <HasPermission data={'view-comments'}>
            <CommunityPostComments />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'comment-replies',
      element: (
        <RequireAuth>
          <HasPermission data={'view-comment-replies'}>
            <PostCommentReplies />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'community-posts',
      element: (
        <RequireAuth>
          <HasPermission data={'view-posts'}>
            <CommunityPosts />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'community-chats',
      element: (
        <RequireAuth>
          <HasPermission data={'view-chats'}>
            <CommunityChats />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'reported-posts',
      element: (
        <RequireAuth>
          <HasPermission data={'view-posts'}>
            <ReportedPosts />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'reported-chats',
      element: (
        <RequireAuth>
          <HasPermission data={'view-chats'}>
            <ReportedChats />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'chat-violations',
      element: (
        <RequireAuth>
          <HasPermission data={'view-chats'}>
            <ChatViolations />
          </HasPermission>
        </RequireAuth>
      )
    },

    // {
    //   path: 'app-users',
    //   element: (
    //     <RequireAuth>
    //       <HasPermission data={'show-app-user'} >
    //       <AppUsersListing />
    //       </HasPermission>
    //     </RequireAuth>
    //   )
    // },
    {
      path: 'sellers',
      element: (
        <RequireAuth>
          <HasPermission data={'view-sellers'}>
            <SellersListing />
          </HasPermission>
        </RequireAuth>
      )
    },

    {
      path: 'app-users-list',
      element: (
        <RequireAuth>
          <HasPermission data={'view-users'}>
            <AppUsersListing />
          </HasPermission>
        </RequireAuth>
      )
    },

    {
      path: 'privacy-policy',
      element: (
        <RequireAuth>
          <HasPermission data={'view-about-us'}>
            <PrivacyPolicy />
          </HasPermission>
        </RequireAuth>
      )
    },

    {
      path: 'terms',
      element: (
        <RequireAuth>
          <HasPermission data={'view-terms-and-condition'}>
            <TermsAndCondition />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'brands',
      element: (
        <RequireAuth>
          <HasPermission data={'view-brands'}>
            <BrandsListing />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'categories',
      element: (
        <RequireAuth>
          <HasPermission data={'view-brands'}>
            <CategoriesManagement />
          </HasPermission>
        </RequireAuth>
      )
    },
    {
      path: 'sizes',
      element: (
        <RequireAuth>
          <HasPermission data={'view-sizes'}>
            <SizingManagement />
          </HasPermission>
        </RequireAuth>
      )
    },

    {
      path: 'permissions',
      element: (
        <RequireAuth>
          <PermissionsListing />
        </RequireAuth>
      )
    },
    {
      path: 'permission-types',
      element: (
        <RequireAuth>
          <PermissionTypes />
        </RequireAuth>
      )
    },
    {
      path: 'subscriptions',
      element: (
        <RequireAuth>
          <UserSubscriptions />
        </RequireAuth>
      )
    }
  ]
};

export default MainRoutes;
